import * as React from "react";
import { useUtilities } from "../../../../context/reports/utilities";
import { MetricsType } from "../../../../context/reports/utilities/types";
import { useActions } from "../../../../context/reports/utilities/useActions";
import { navigate } from "../../../../utils/routes/navigate";

/**
 * Handles utilities effect
 * @param metricsType
 * @param selectedSites
 * @param currentSiteId current site identifer is set on single site scene only
 */
export function useUtilitiesEffect(
  metricsType: MetricsType,
  selectedSites: string[],
  currentSiteId?: string
) {
  const [state] = useUtilities();
  const { getMetrics, setMetricsType, setSelectedSites } = useActions();

  /**
   * Set metrics type into state if it's been changed
   */
  React.useEffect(() => {
    setMetricsType(metricsType);
  }, [metricsType]);

  /**
   * Set selected sites into state if it's been changed
   */
  React.useEffect(() => {
    const selected = [...new Set(selectedSites)];
    if (
      state.selectedSites.length !== selected.length ||
      state.selectedSites.every((value, index) => value !== selected[index])
    ) {
      setSelectedSites(selectedSites);
    }
  }, [selectedSites]);

  /**
   * Specific effect for single site scene
   * Observe selected sites and navigate to portfolio view, but only when
   * selected sites does not include current single site id
   */
  React.useEffect(() => {
    if (currentSiteId && !selectedSites.includes(currentSiteId)) {
      navigate(`/reports/performance/utilities/${metricsType.toLowerCase()}`)();
      return;
    }
  }, [selectedSites, currentSiteId]);

  /**
   * Handle metrics requests
   */
  React.useEffect(() => {
    if (!state.metricsLoaded[metricsType] && !state.metricsLoading) {
      void getMetrics(
        metricsType,
        selectedSites,
        state.startDate,
        state.endDate
      );
    }
  }, [metricsType, state.metricsLoaded, state.metricsLoading]);
}
